import { c as _c } from "react/compiler-runtime";
import { useModalStore } from "@/stores/modal-store";
interface ModalLayoutProps {
  children: React.ReactNode;
  onClose: () => void;
}
export default function ModalLayout(t0) {
  const $ = _c(19);
  const {
    children,
    onClose
  } = t0;
  const {
    modalConfig
  } = useModalStore();
  const layoutOptions = modalConfig?.layoutOptions;
  if (!layoutOptions) {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = `flex flex-col relative ${layoutOptions.className || ""}`;
  let t2;
  if ($[2] !== layoutOptions.header) {
    t2 = layoutOptions.header && <div className="px-6 py-4 border-b">{layoutOptions.header}</div>;
    $[2] = layoutOptions.header;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== layoutOptions.closeButtonPosition || $[5] !== layoutOptions.showCloseButton || $[6] !== onClose) {
    t3 = layoutOptions.showCloseButton && <button onClick={onClose} className={`absolute p-2 hover:bg-gray-100 rounded-full transition-colors ${layoutOptions.closeButtonPosition === "top-left" ? "left-4" : "right-4"} top-4`}><svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg></button>;
    $[4] = layoutOptions.closeButtonPosition;
    $[5] = layoutOptions.showCloseButton;
    $[6] = onClose;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = `flex-1 ${layoutOptions.padding || ""}`;
  let t5;
  if ($[8] !== children || $[9] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[8] = children;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== layoutOptions.footer) {
    t6 = layoutOptions.footer && <div className="px-6 py-4 border-t">{layoutOptions.footer}</div>;
    $[11] = layoutOptions.footer;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className={t1}>{t2}{t3}{t5}{t6}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}